import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RpMappingComponent } from './rp-mapping.component';

const routes: Routes = [
  { path: 'projectDetails/mapping', component: RpMappingComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MetersRoutingModule {}
